import { render, staticRenderFns } from "./LoadTesting.vue?vue&type=template&id=21a34448&scoped=true"
import script from "./LoadTesting.vue?vue&type=script&lang=js"
export * from "./LoadTesting.vue?vue&type=script&lang=js"
import style0 from "./LoadTesting.vue?vue&type=style&index=0&id=21a34448&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a34448",
  null
  
)

export default component.exports